import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_KEY;
if (!supabaseUrl) throw Error("Missing supabase url");
if (!supabaseKey) throw Error("Missing supabase api key");

console.log("Loading supabase client");

export const supabaseClient = createClient(supabaseUrl, supabaseKey);